module.exports = __webpack_public_path__ + "img/orange-money.21d1cf0c.svg";